<ng-template [ngIf]="article" [ngIfElse]="loader">
<div class="flex items-center space-x-2 mb-6">
  <img src="{{article.image?.thumbnailUrl}}" class="max-w-[70px] w-70 h-70" loading="lazy" />
  <h4 class="font-bold text-xs"><a href="{{article.routerLink}}">{{article.title}}</a></h4>
</div>
</ng-template>
<ng-template #loader>
  <div class="loader"><la-icon class="animate-spin" icon="spinner" size="2x"></la-icon></div>
</ng-template>
